'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'arrow-up';
var width = 384;
var height = 512;
var aliases = [8593];
var unicode = 'f062';
var svgPathData = 'M203.4 4.7l-11.3-11.3-11.3 11.3-176 176-11.3 11.3 22.6 22.6 11.3-11.3 148.7-148.7 0 457.4 32 0 0-457.4 148.7 148.7 11.3 11.3 22.6-22.6-11.3-11.3-176-176z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;